import { gql } from 'graphql-request';

export const CACHE_CREATE_CUSTOM_FIELD_VALUE_QUERY = gql`
  mutation CacheCreateCustomFieldValue(
    $companyUuid: ID!
    $customFieldUuid: ID!
    $defaultAt: DateTime
    $text: String!
  ) {
    createCustomFieldValue(
      input: {
        companyUuid: $companyUuid
        customFieldUuid: $customFieldUuid
        defaultAt: $defaultAt
        text: $text
      }
    ) {
      errors {
        fullMessages
      }
      record {
        companyId
        createdAt
        customFieldId
        defaultAt
        id
        text
        updatedAt
        uuid
      }
      recordId
      recordNanoId
      recordUuid
      status
    }
  }
`;
